//
//
//
//
//
//
//
//
export default {
  name: 'MdmLink',
  props: {
    url: {
      type: String,
      required: true
    },
    isNuxt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    link() {
      return {
        [this.isNuxt ? 'to' : 'href']: this.url
      };
    },

    component() {
      return this.isNuxt ? 'nuxt-link' : 'a';
    }

  }
};